<div class="px-6 py-4">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-2xl font-bold text-gray-800">Comanda #{{ comanda?.number ?? '—' }}</h1>
    <div class="flex gap-2">
      <button
        *ngIf="comanda?.status === 'ABERTA'"
        pButton
        type="button"
        label="Fechar comanda"
        icon="pi pi-lock"
        class="p-button-success"
        (click)="fechar()"
      ></button>
      <button
        *ngIf="comanda?.status === 'ABERTA'"
        pButton
        type="button"
        label="Cancelar comanda"
        icon="pi pi-times"
        class="p-button-danger"
        (click)="cancelar()"
      ></button>
      <button
        pButton
        type="button"
        label="Voltar"
        icon="pi pi-arrow-left"
        class="p-button-secondary"
        (click)="goBack()"
      ></button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-8 text-gray-500">Carregando...</div>

  <div *ngIf="!loading && comanda" class="space-y-4">
    <p-card>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <span class="text-sm text-gray-500">Status</span>
          <p-tag
            [value]="comanda.status"
            [severity]="getStatusSeverity(comanda.status)"
            [rounded]="false"
            class="block mt-1"
          ></p-tag>
        </div>
        <div>
          <span class="text-sm text-gray-500">Garçom</span>
          <p class="font-medium">{{ comanda.employeeName || '—' }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-500">Abertura</span>
          <p class="font-medium">{{ formatDate(comanda.openedAt) }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-500">Fechamento</span>
          <p class="font-medium">{{ formatDate(comanda.closedAt) }}</p>
        </div>
      </div>
      <div *ngIf="comanda.observation" class="mt-4 pt-4 border-t">
        <span class="text-sm text-gray-500">Observação</span>
        <p class="mt-1">{{ comanda.observation }}</p>
      </div>
    </p-card>

    <p-card header="Mesas" *ngIf="comanda.tables?.length">
      <p-table [value]="comanda.tables" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Número</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-t>
          <tr>
            <td class="font-mono">{{ t.number }}</td>
            <td>{{ t.status }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card header="Itens" *ngIf="comanda.items?.length">
      <p-table [value]="comanda.items" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Produto</th>
            <th class="text-right">Qtd</th>
            <th class="text-right">Preço unit.</th>
            <th class="text-right">Total</th>
            <th>Obs.</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.productName || '—' }}</td>
            <td class="text-right">{{ item.quantity | number }}</td>
            <td class="text-right">R$ {{ item.unitPrice | number:'1.2-2' }}</td>
            <td class="text-right">R$ {{ item.total | number:'1.2-2' }}</td>
            <td>{{ item.observation || '—' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card>
      <div class="flex justify-end gap-6 text-right">
        <div>
          <span class="text-sm text-gray-500">Subtotal</span>
          <p class="text-lg font-medium">R$ {{ comanda.subtotal | number:'1.2-2' }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-500">Desconto</span>
          <p class="text-lg font-medium">R$ {{ comanda.discount | number:'1.2-2' }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-500">Total</span>
          <p class="text-xl font-bold text-gray-900">R$ {{ comanda.total | number:'1.2-2' }}</p>
        </div>
      </div>
    </p-card>
  </div>

  <div *ngIf="!loading && !comanda" class="text-center py-8 text-gray-500">
    Comanda não encontrada.
  </div>
</div>
